import React, { useState } from "react";
import AzureAuthenticationContext from "src/azure/azure-authentication-context";
import { AccountInfo } from "@azure/msal-browser";
import AzureAuthenticationRedirectContext from "./azure-authentication-redirect-context";
import LogoMicrosoft from "src/assets/images/logoMicrosoft.svg";
import styled from "styled-components";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const chrome = ua.indexOf("chrome");
const isIE = msie > 0 || msie11 > 0;

// Log In, Log Out button

const AzureAuthenticationButton = ({ onAuthenticated }: any): JSX.Element => {
  // Azure client context
  const authenticationModule: AzureAuthenticationContext = new AzureAuthenticationContext();
  const authenticationRedirectModule: AzureAuthenticationRedirectContext = new AzureAuthenticationRedirectContext();

  // const [authenticated, setAuthenticated] = useState<boolean>(false);
  const [user, setUser] = useState<AccountInfo>();
  // const [token, setToken] = useState<string>();

  const logIn = (method: string): any => {
    // const typeName = "loginPopup";
    // const typeName = "loginRedirect";
    // const logInType = isIE ? "loginRedirect" : typeName;
    const logInType = method;
    // const logInType = "loginRedirect";
    // Azure Login
    // authenticationModule.login(logInType, returnedAccountInfo);
    const result = authenticationRedirectModule.login(returnToken);
  };

  // 사용 안함
  const logOut = (): any => {
    if (user) {
      onAuthenticated(undefined);
      // Azure Logout
      authenticationModule.logout(user);
    }
  };

  // const returnedAccountInfo = (user: AccountInfo) => {
  //   // set state
  //   setAuthenticated(user?.name ? true : false);
  //   onAuthenticated(user);
  //   setUser(user);
  // };

  const returnToken = (token: string) => {
    // setAuthenticated(token ? true : false);
    onAuthenticated(token);
    // setToken(token);
  };

  const showLogInButton = (): any => {
    return (
      //loginRedirect / loginPopup
      // 이 div 에는 onClick 을 달지 않는다. 이것은 로고를 그리는 표시 요소이고,
      // 활성화는 이 컴포넌트를 감싸는 실제 <button> 이 받는다(login.tsx).
      // 예전에는 여기 onClick 이 달려 있어 마우스로는 눌렸지만 버튼을 대상으로 하는
      // 활성화 즉 키보드 Enter 및 Space, 보조기술, 프로그램 호출이 전부 무동작이었다.
      // 여기에 다시 달면 마우스 클릭이 버블링으로 두 번 발사된다.
      <div id="authenticationButton" className="ms-logo" aria-hidden="true">
        {/* 본사 MS 로그인 */}
      </div>
    );
  };

  const showLogOutButton = (): any => {
    return (
      <div id="authenticationButtonDiv">
        <div id="authentication">
          <div id="authenticationButton" onClick={() => logOut()}></div>
        </div>
      </div>
    );
  };

  const showButton = (): any => {
    // return authenticated ? showLogOutButton() : showLogInButton();
    return showLogInButton();
  };

  return (
    <MsLoginBtn id="authentication">
      {authenticationModule.isAuthenticationConfigured ? showButton() : <div>Authentication Client ID is not configured.</div>}
    </MsLoginBtn>
  );
};

const MsLoginBtn = styled.div`
  width: 100%;
  height: 100%;
  > .ms-logo {
    display: inline-block;
    width: 100%;
    height: 100%;
    background: url(${LogoMicrosoft}) no-repeat center center;
    background-size: 110px 24px;
  }
`;

export default AzureAuthenticationButton;
